import * as Colors from "../../../../globalStyles/administratorColors";

export const body = {
    paddingRight: "30px",
    paddingTop: "20px"
};

export const newPostageButton = {
    textAlign: "right"
};

export const cardHeader = {
    backgroundColor: Colors.primary,
    color: "white",
    fontWeight: "bold"
};

export const cardStyle = {
    backgroundColor: Colors.primary,
    color: "white"
};

export const cardNotActiveStyle = {
    backgroundColor: "darkRed",
    color: "white"
};

export const columnStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "10px"
};

export const buttonColStyle = {
    textAlign: "center"
};
